export default function TableSkeleton({ rows = 8, className = '' }) {
  return (
    <div role="status" aria-label="Loading" className={`space-y-3 animate-pulse ${className}`}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-10 rounded-md bg-gray-200/70 dark:bg-gray-700/50" />
      ))}
      <span className="sr-only">Loading...</span>
    </div>
  );
}
